import { Link } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Image1 from "../asset/Images/mydataim.avif";


function Hero() {
  return (
    <section className="relative bg-purple-80 mt-1 sm:mt-2 lg:mt-3">  {/* ← ADD THIS */}
      <div className="w-full min-h-[55vh] lg:min-h-[65vh] flex flex-col lg:flex-row items-center justify-center py-8 sm:py-10 lg:py-12">

        {/* Text — below on mobile, left on desktop */}
        <div className="w-full lg:w-1/2 order-2 lg:order-1 text-center lg:text-left">
          <h1
            className="font-extrabold leading-tight text-[#111]"
            style={{ fontSize: "clamp(28px, 5vw, 62px)" }}
          >
            Turning Ideas <br />
            <span className="ml-2 bg-gradient-to-r from-[#d946ef] to-[#7c3aed] bg-clip-text text-transparent">
              Into&nbsp;&nbsp;Into Real Life Products
            </span>
          </h1>

          <p
            className="text-gray-600 leading-relaxed mt-5 mx-auto lg:mx-0"
            style={{ fontSize: "clamp(14px, 1.1vw, 18px)", maxWidth: "520px" }}
          >
            We help startups and businesses bring their idead to life through industrial design, enginering, prototyping, and manufactuering support
          </p>

          <div className="flex flex-wrap gap-4 mt-8 justify-center lg:justify-start">
            <Link
              to="/service"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gradient-to-r from-[#d946ef] to-[#7c3aed] text-white font-semibold hover:scale-105 transition-all duration-300 shadow-lg"
            >
              Explore Services
              <ArrowForwardIcon />
            </Link>

            <Link
              to="/contact"
              className="inline-flex items-center px-6 py-3 rounded-full border-2 border-purple-300 text-purple-700 font-semibold hover:bg-purple-50 transition-all duration-300"
            >
              Contact Us
            </Link>
          </div>
        </div>

        {/* Image — on top on mobile, right on desktop */}
        <div className="w-full lg:w-3/5 order-1 lg:order-2 flex items-center justify-center lg:justify-end">
          <img
            src={Image1} fetchPriority="High"
            alt="Product Development"
            className="w-auto max-h-[40vh] lg:max-h-[80vh] max-w-full object-contain"
          />
        </div>

      </div>
    </section>
  );
}

export default Hero;